import { render, staticRenderFns } from "./InputSimpleRating.vue?vue&type=template&id=ac4d8926&scoped=true&"
import script from "./InputSimpleRating.vue?vue&type=script&lang=ts&"
export * from "./InputSimpleRating.vue?vue&type=script&lang=ts&"
import style0 from "./InputSimpleRating.vue?vue&type=style&index=0&id=ac4d8926&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4d8926",
  null
  
)

export default component.exports